// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { StoneShapeFragmentDoc } from '../../nonsku/fragments/stoneShape.fragment.generated';
export const GemsApiStoneShapeWithInfoFragmentDoc = gql`
    fragment GemsApiStoneShapeWithInfo on GemsApi_StoneShapeInfo {
  code
  info {
    ...stoneShape
  }
}
    ${StoneShapeFragmentDoc}`;